import React from 'react'
import { observer } from 'mobx-react'
import TagManager from 'react-gtm-module'
import { personalOfferContainer } from 'src/models'
import { getLocaleCodeFromUrl } from 'src/utils'
import { trackErrorInInstana } from 'src/utils/commonUtils'
import { NoOfferHereIcon } from './NoOfferHereIcon'
import { DEFAULT_TITLE, DEFAULT_DESCRIPTION, DEFAULT_BUTTON } from './constants'
import './styles.scss'

const isEnglishLocale = () => {
  try {
    const locale = getLocaleCodeFromUrl({ defaultLocale: 'en_US' }) || 'en_US'
    return locale.toLowerCase().startsWith('en')
  } catch (e) {
    return true
  }
}

const getTranslations = () => {
  const csValues = personalOfferContainer?.productOffersCSValues || {}
  const noOffer = csValues?.errorMessages?.poNoOfferMessage || {}
  return {
    title: noOffer?.title || DEFAULT_TITLE,
    description: noOffer?.description || DEFAULT_DESCRIPTION,
    buttonText: csValues?.buttonLabelClickHereToVisitMyStore || DEFAULT_BUTTON,
  }
}

const NoOfferHereComponent = ({ onButtonClick }) => {
  if (!personalOfferContainer?.productOffersCSValues && !isEnglishLocale()) {
    return null
  }

  const { title, description, buttonText } = getTranslations()

  const handleButtonClick = () => {
    if (typeof onButtonClick === 'function') {
      onButtonClick()
    }
  }

  return (
    <main className="no-offer-here-container" data-testid="no-offer">
      <div className="no-offer-here-content">
        <div className="no-offer-here-illustration" aria-hidden="true">
          <NoOfferHereIcon />
        </div>

        <div className="no-offer-here-text-content">
          <div className="no-offer-here-text-section">
            <h1 className="no-offer-here-title" tabIndex={0}>
              {title.split('\n').map((line, index, array) => (
                <React.Fragment key={`${line}-${index}`}>
                  {line}
                  {index < array.length - 1 && <br />}
                </React.Fragment>
              ))}
            </h1>

            <p className="no-offer-here-description" tabIndex={0}>
              {description}
            </p>
          </div>

          <div className="no-offer-here-button-section">
            <button
              type="button"
              className="no-offer-here-button"
              onClick={handleButtonClick}
              data-testid="qa-no-offer-here-cta">
              <span className="no-offer-here-button-content">
                <span className="no-offer-here-button-text">{buttonText}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </main>
  )
}

class NoOfferHere extends React.Component {
  componentDidMount() {
    if (
      !personalOfferContainer?.productOffersCSValues &&
      typeof personalOfferContainer?.getProductOffersCSValues === 'function'
    ) {
      personalOfferContainer.getProductOffersCSValues().catch(() => {})
    }

    try {
      TagManager.dataLayer({
        dataLayer: {
          event: 'no_offer_view',
          page_type: 'no_offer',
          user_id: this.props.userId || '',
          pitch_id: this.props.pitchId || '',
          reason: this.props.reason || 'invalid_link',
        },
      })
    } catch (error) {
      trackErrorInInstana({
        errorReport: 'Failed to track no offer view',
        errorData: { response: error },
      })
    }
  }

  render() {
    return <NoOfferHereView {...this.props} />
  }
}

const NoOfferHereView = observer(NoOfferHereComponent)

export default NoOfferHere
export { NoOfferHere }
